export enum TextFieldType {
    DYNAMIC = "dynamic",
    INPUT = "input",
}
